import { render, staticRenderFns } from "./BCOptionalFeaturesDisplay.vue?vue&type=template&id=0ae71f7d"
import script from "./BCOptionalFeaturesDisplay.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports